import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface BreadcrumbProps {
  items: BreadcrumbItem[];
}
export function Breadcrumb({
  items
}: BreadcrumbProps) {
  return <nav className="flex mb-8" aria-label="Breadcrumb" data-id="element-18">
      <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-19">
        <li className="inline-flex items-center" data-id="element-20">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-[#0af]" data-id="element-21">
            <Home className="w-4 h-4 mr-2" data-id="element-22" />
            Inicio
          </Link>
        </li>
        {items.map((item, index) => <li key={index} data-id="element-23">
            <div className="flex items-center" data-id="element-24">
              <ChevronRight className="w-4 h-4 text-gray-400" data-id="element-25" />
              {item.href ? <Link to={item.href} className="ml-1 text-sm font-medium text-gray-500 hover:text-[#0af] md:ml-2" data-id="element-26">
                  {item.label}
                </Link> : <span className="ml-1 text-sm font-medium text-[#022a3b] md:ml-2" data-id="element-27">
                  {item.label}
                </span>}
            </div>
          </li>)}
      </ol>
    </nav>;
}